'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _UiReducer = require('./UiReducer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This HOC is used to get mobile/deskop layout calculated from media query breakpoints 
 */
var MobileLayoutHOC = function MobileLayoutHOC(WrappedComponent) {
  var BaseComponent = function BaseComponent(props) {
    return _react2.default.createElement(WrappedComponent, props);
  };

  var mapStateToProps = function mapStateToProps(state) {
    var isMobileLayout = (0, _UiReducer.getIsMobileLayout)(state.ui);

    return {
      isMobileLayout: isMobileLayout
    };
  };

  return (0, _reactRedux.connect)(mapStateToProps)(BaseComponent);
};

exports.default = MobileLayoutHOC;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/ui/MobileLayoutHOC.js
// module id = 358
// module chunks = 10